import { Close, FileUploadIcon  } from "../../../assets/svg";
import { classNames } from "../../../lib/classNames";

import styles from "./FileContent.module.scss";

import type { FC } from "react";
import type { MouseEvent } from "react"

interface FileContentProps {
  content: string;
  isFile: boolean;
  extension?: string;
  onClear?: () => void;
}

export const FileContent: FC<FileContentProps> = ({ content, extension, isFile, onClear }) => {

    const handleClear = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        onClear?.();
    }

    return (
        <div className={styles.area}>
            {isFile && <FileUploadIcon className={styles.fileIcon} />}
            <div className={classNames({ cls: styles.content, mods: { [styles.file]: isFile} })}>
                <span  className={styles.name}>
                    {content}
                </span>
                {isFile && extension}
            </div>
            {isFile && (
                <button onClick={handleClear}>
                    <Close className={styles.close} />
                </button>
            )}
        </div>
    )
}
